export enum Source {
  dataCleaning = "DataCleaning",
  prospects = "Prospects",
}
